export const AnimatedLogo = ({ className = "w-16", entrance = "logo-wrap", testId = "animated-logo" }) => (
  <div className={`${entrance} logo-hover ${className}`} data-testid={testId}>
    <div className="logo-float">
      <div className="logo-glow" style={{ "--logo-mask": "url(/assets/logo-anim.png)" }}>
        <img src="/assets/logo-anim.png" alt="ASAP & Co. Custom Print Group logo" draggable="false" />
      </div>
    </div>
  </div>
);
